import { render, staticRenderFns } from "./ShipmentProfileFilters.vue?vue&type=template&id=276cbf9d&"
import script from "./ShipmentProfileFilters.vue?vue&type=script&lang=js&"
export * from "./ShipmentProfileFilters.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports